module.exports = __webpack_public_path__ + "static/partner-img6-b656af8613a623c96bc801997d1520c0.png";